import React from 'react';
import PropTypes from 'prop-types';

import config from '../../../../../../../config';
import SendIcon from "../../../../../../../assets/icons/SendIcon";
import TableAction from "../../../../../../../components-new/table/TableAction";
import colors from "../../../../../../../utils/Colors";
import DeleteIcon from "../../../../../../../assets/icons/DeleteIcon";
import LockKeyholeIcon from "../../../../../../../assets/icons/LockKeyholeIcon";
import PersonIcon from "../../../../../../../assets/icons/PersonIcon";

const MembersTableRowActions = ({removeMember, reInviteMember, changePassword, editProfile, member}) => {

    return (
        <div className="table-actions">
            {member.platformId && (
                <React.Fragment>
                    <TableAction
                        tooltip="profile"
                        onClick={() => editProfile(member)}
                        icon={<PersonIcon width={18} height={18} stroke="currentColor"/>}
                    />
                    <TableAction
                        tooltip="changePassword"
                        onClick={() => changePassword(member)}
                        icon={<LockKeyholeIcon width={18} height={18} stroke="currentColor"/>}
                    />
                </React.Fragment>
            )}

            {member.status === config.statusMap.pending && (
                <TableAction
                    tooltip="resendInvitation"
                    onClick={() => reInviteMember(member)}
                    icon={<SendIcon width={18} height={18} stroke="currentColor"/>}
                />
            )}

            <TableAction
                tone="danger"
                tooltip="removeUser"
                onClick={removeMember}
                icon={<DeleteIcon width={18} height={18} stroke={colors.red}/>}
            />
        </div>
    )
}

MembersTableRowActions.propTypes = {
    member: PropTypes.object.isRequired,
    reInviteMember: PropTypes.func.isRequired,
    removeMember: PropTypes.func.isRequired,
    changePassword: PropTypes.func.isRequired,
    editProfile: PropTypes.func.isRequired,
};

export default MembersTableRowActions;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/EmployeesTable/partials/MembersTableRowActions.jsx